module.exports = __webpack_public_path__ + "media/images/consumer/account/upcoming-menus/promo-banners/less-prep/dish@1x-93154d81a688925fd7f2ddac84f80ecc.webp";